import React from 'react';
import '../../assets/styles/LoginRegister.css';

const LoginSuccess = () => {
    return (
        <div className="login-register-container">
            <h2>登录成功！</h2>
            <p>您已成功登录系统。</p>
        </div>
    );
};

export default LoginSuccess; 